import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { securityGuard } from './security/guard-fn/security.guard';


const routes: Routes = [
  // path is login which loadChildren is login module
  { path: 'login', loadChildren: () => import('src/app/login/login.module').then(m => m.LoginModule) },
  // path is register which loadChildren is register module
  { path: 'register', loadChildren: () => import('src/app/register/register.module').then(m => m.RegisterModule) },
  { path: '', loadChildren: () => import('src/app/frontend/frontend.module').then(m => m.FrontendModule), canActivate: [securityGuard] },
  // redirect to login if path is wildcard, and pathMatch is full
  // { path: '**', redirectTo: 'login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
